import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@/components/ui/Drawer/drawer';
import { cn } from '@/utils/cn';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  contentClassName?: string;
  classNamePointer?: string;
  classNameDrawerContent?: string;
}

const BottomSheetModal = ({ classNamePointer, open, onOpenChange, classNameDrawerContent, children, contentClassName }: Props) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange} direction="bottom">
      <VisuallyHidden.Root>
        <DrawerTitle>Bottom Sheet Modal</DrawerTitle>
        <DrawerDescription>Bottom Sheet Modal</DrawerDescription>
      </VisuallyHidden.Root>
      <DrawerContent className={cn('bg-main-800 border-none text-white rounded-t-2xl px-6 pb-5 pt-3', classNameDrawerContent)}>
        <div className={cn('mx-auto mb-7 h-1 w-10 shrink-0 rounded-full bg-c600', classNamePointer)} />

        <div className={cn('flex flex-col', contentClassName)}>
          {children}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default BottomSheetModal;
